export default __webpack_public_path__ + "static/media/avatar_fairy_pixie1.0d9d62ce.mp3";